import { render, staticRenderFns } from "./ListaPostAdmin.vue?vue&type=template&id=339f5669"
import script from "./ListaPostAdmin.vue?vue&type=script&lang=js"
export * from "./ListaPostAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports